import { UPDATES_AS_OF } from './snowflakeUpdates';

const UPDATE_MONTH_INDEX = {
  January: 0,
  February: 1,
  March: 2,
  April: 3,
  May: 4,
  June: 5,
  July: 6,
  August: 7,
  September: 8,
  October: 9,
  November: 10,
  December: 11,
};

/** Parse "October 20, 2026". Missing dates fall back to UPDATES_AS_OF. */
export function updateCardTime(card) {
  const value = (card && card.asOf) || UPDATES_AS_OF;
  const match = /^([A-Za-z]+)\s+(\d{1,2}),\s+(\d{4})$/.exec(value);
  if (!match || UPDATE_MONTH_INDEX[match[1]] == null) return 0;
  return Date.UTC(Number(match[3]), UPDATE_MONTH_INDEX[match[1]], Number(match[2]));
}

/** Newest asOf first. Equal dates keep their existing order. */
export function sortUpdateIndexCards(cards) {
  return [...cards].sort((a, b) => updateCardTime(b) - updateCardTime(a));
}

/**
 * Phrase that used to be the /updates preview after that note left the index.
 * Kept here so a later copy change cannot put it back into the head.
 */
export const RETIRED_UPDATES_PREVIEW = 'Semantic Studio is now GA';

/**
 * Meta description for the /updates index.
 * The page lede is the neutral preview. When that sentence announces a note
 * that is not on the index, the newest note title is used instead.
 */
export function updatesIndexDescription(cards, lede) {
  const list = Array.isArray(cards) ? cards : [];
  const newest = sortUpdateIndexCards(list)[0];
  const noteText = list.map((card) => `${card.title} ${card.summary}`).join('\n');
  const sentence = typeof lede === 'string' ? lede.trim() : '';
  const announcesMissingNote =
    sentence.includes(RETIRED_UPDATES_PREVIEW) && !noteText.includes(RETIRED_UPDATES_PREVIEW);
  if (announcesMissingNote && newest) return newest.title;
  if (sentence) return sentence;
  return newest ? newest.title : '';
}
